let moment = require('moment');
/**
 * @class DisposalService
 */
function DisposalService($q, $log, disposalBackend, $root) {
    var self = this;

    self.financementList = [
        {id: null, value: ''},
        {id: 'Location', value: 'Location'},
        {id: 'Achat', value: 'Achat'},
        {id: 'Extension', value: 'Extension'},
        {id: 'Reprise LJ', value: 'Reprise Lj'},
        {id: 'IDH', value: 'IDH'},
        {id: 'Prolongation', value: 'Prolongation'},
        {id: 'Renouvellement', value: 'Renouvellement'}
    ];
    self.leaser = [
        {id: null, value: ''},
        {id: 'NAP SERVICES', value: 'NAP SERVICES'},
        {id: 'BNP LEASE GROUP', value: 'BNP LEASE GROUP'},
        {id: 'RELEASE CAPITAL', value: 'RELEASE CAPITAL'},
        {id: 'LEASING ADOSSE', value: 'LEASING ADOSSE'},
        {id: 'LEASECOM', value: 'LEASECOM'},
        {id: 'GRENKE', value: 'GRENKE'},
        {id: 'LEASCORP', value: 'LEASCORP'}
    ];
    self.typesCaisse = [
        {id: null, value: ''},
        {id: 'BWIDE', value: 'BWIDE'},
        {id: 'BSWIFT', value: 'BSWIFT'},
        {id: 'BTOUCH', value: 'BTOUCH'},
        {id: 'BSMART', value: 'BSMART'},
        {id: 'BHAPPY+', value: 'BHAPPY+'},
        {id: 'BFRIENDLY', value: 'BFRIENDLY'},
        {id: 'BGREEN', value: 'BGREEN'},
        {id: 'BMOOV', value: 'BMOOV'},
        {id: 'BMOOV+', value: 'BMOOV+'},
        {id: 'SCANUP SEUL', value: 'SCANUP SEUL'}
    ];
    self.nbCaisse = [
        {id: null, value: ''},
        {id: 1, value: 1},
        {id: 2, value: 2},
        {id: 3, value: 3},
        {id: 4, value: 4},
        {id: 5, value: 5},
        {id:6, value: 6}
    ];
    self.interlocuteurs = [
        {id: null, value: ''},
        {id: 'Vendeur', value: 'Vendeur'},
        {id: 'Repreneur', value: 'Repreneur'},
        {id: 'Agence', value: 'Agence'},
        {id: 'Notaire', value: 'Notaire'},
        {id: 'RDS', value: 'RDS'}
    ];
    self.sources = [
        {id: null, value: ''},
        {id: 'Mail', value: 'Mail'},
        {id: 'Courrier', value: 'Courrier'},
        {id: 'Téléphone', value: 'Téléphone'},
        {id: 'RDS', value: 'RDS'}
    ];

    /**
     * get the store's disposals
     * @param  {String} storeId
     * @return {promise}
     */
    self.getDisposals = function (storeId) {
        var d = $q.defer();
        disposalBackend.getDisposals(storeId).then(function(disposals) {
            disposals.forEach(function(disposal) {
                disposal.created_date = moment(disposal.created_date, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY');
            });

            d.resolve(disposals);
        }, d.reject.bind(d));
        return d.promise;
    };

    /**
     * Add a new disposal
     * @param {String} storeId
     * @param {Object} disposal
     * @return {Promise}
     */
    self.saveDisposal = function (disposal){
        return disposalBackend.saveDisposal(disposal).then(function (res) {
            return res;
        });
    };

    return self;
}
DisposalService.$inject = ['$q', '$log', 'disposalBackend', '$rootScope'];

angular.module('app.prospection.store.disposalService', []).factory('disposalService', DisposalService);
